import React, { Component, Fragment } from "react";
import CustomCheckBox from "../common/CustomCheckBox";

class AddItemForm extends Component {

  state = {
    itemNumber: "",
    leadTimeExempt: true,
    availableInventory: true,
    category: "R",
    qtyOrdered: 0,
  };

  constructor() {
    super();
    this.categories = {
      R: "R-REG",
      P: "P-PLN",
      Q: "Q-QAD",
      S: "S-SEA",
      Z: "Z-RDZ",
      O: "O-OFS",
      M: "M-MEG",
      H: "H-HOL",
      F: "F-FOG",
      D: "D-DNR",
      B: "B-FWD",
      A: "A-ADV"
    };
  }


  renderCategories = () => {
    return Object.keys(this.categories).map(cat => {
      return (
        <option key={cat} value={cat}>
          {this.categories[cat]}
        </option>
      );
    });
  };
  onBlurItemNumber = () => {};
  validateItemNumber = value => {
    var filteredQuery;
    filteredQuery = value.slice(0, 9).replace(/[^\d.-]/g, "");
    if (value.length > 9) {
      this.props.setErrorMessage("Must Be 1-9 Characters");
    } else if (value.match(/[^\d.-]/g, "")) {
      this.props.setErrorMessage("Item is number");
    } else if (value.length < 1) {
      this.props.setErrorMessage("Set item");
    } else if (this.props.validateDuplicated(value)) {
      this.props.setErrorMessage("Duplicate not allowed");
    } else {
      this.props.setErrorMessage(false);
    }
    this.setState({ itemNumber: filteredQuery });
  };
  // poNumber, suffix, whse, itemNumber, fbuyFlag, availFlag, qtyOrdered, invCategory
  onKeyPress = e => {
    if (e.key === "ArrowUp" || e.key === "ArrowRight") {
      this.handleChangeQtyOrdered(e, 1);
    }
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") {
      this.handleChangeQtyOrdered(e, -1);
    }
  };

  clearState = (param) => {
    if(window.test3 == true) {
      this.setState({
        itemNumber: "",
        leadTimeExempt: true,
        availableInventory: true,
        category: "R",
        qtyOrdered: 0,
      })
      window.test3 = false;
    } 
  };

  handleChangeQtyOrdered = (e, num) => {
    if (this.state.qtyOrdered + num > 0) {
      this.setState({
        qtyOrdered: parseInt(this.state.qtyOrdered, 10) + num
      });
    } else {
      this.props.setErrorMessage("You should enter 1 at least");
    }
  };
  
  componentDidUpdate() {
    if (
      this.state.itemNumber &&
      !this.props.validateDuplicated(this.state.itemNumber) &&
      this.state.qtyOrdered > 0
    ) {
      this.props.setErrorMessage(false);
      this.props.areAllFieldsFilled(true, {
        itemNumber: this.state.itemNumber,
        fbuyFlag: this.state.leadTimeExempt,
        availFlag: this.state.availableInventory,
        invCategory: this.state.category ? this.state.category : "R",
        qtyOrdered: this.state.qtyOrdered
      });
    } else {
      this.props.areAllFieldsFilled(false);
    }
  }

  handleOnChangeCheckbox = (e, property) => {
    this.setState({ [property]: e.target.checked });
  };

 

  render() {
    this.clearState(window.test3);
    return (
      <div className="form-wrapper" id="addModal">
        <h1>Add Item</h1>

        <div className="input-group add-item-input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">Item Number</span>
            <input
              type="text"
              className="form-control"
              onChange={e => this.validateItemNumber(e.target.value)}
              value={this.state.itemNumber}
            />
          </div>
        </div>
        <div className="input-group add-item-input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">Lead Time Exempt</span>
          </div>
          <CustomCheckBox
            onChange={this.handleOnChangeCheckbox}
            checked={this.state.leadTimeExempt}
            property={"leadTimeExempt"}
          />
        </div>
        <div className="input-group add-item-input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">Available Inventory</span>
          </div>
          <CustomCheckBox
            onChange={this.handleOnChangeCheckbox}
            checked={this.state.availableInventory}
            property={"availableInventory"}
          />
        </div>
        <div className="input-group add-item-input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">Quantity Ordered</span>
          </div>
          <Fragment>
            <i
              className="material-icons"
              onClick={e => this.handleChangeQtyOrdered(e, -1)}
            >
              navigate_before
            </i>
            <input
              className="table-text qty-input form-control"
              onKeyDown={e => this.onKeyPress(e)}
              // defaultValue={row.pod_qty_ordered}
              value={this.state.qtyOrdered}
              onChange={e =>
                this.setState({ qtyOrdered: parseInt(e.target.value, 10) })
              }
            />
            <i
              className="material-icons"
              onClick={e => this.handleChangeQtyOrdered(e, 1)}
            >
              navigate_next
            </i>
          </Fragment>
        </div>

        <div className="input-group add-item-input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">Category</span>
          </div>
          <select
            type="text"
            className="form-control"
            onChange={e => this.setState({ category: e.target.value })}
            value={this.state.category}
          >
            {this.renderCategories()}
          </select>
        </div>
      </div>
    );
  }
}


export default AddItemForm;
